import { render, staticRenderFns } from "./EditServiceDialog.vue?vue&type=template&id=d2b97196"
import script from "./EditServiceDialog.vue?vue&type=script&lang=js"
export * from "./EditServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditServiceDialog.vue?vue&type=style&index=0&id=d2b97196&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports